<app-scotty-card
  [title]="title"
  [fullWidth]="true"
  [fullHeight]="true"
  [canGoBack]="true"
  [backLevels]="backLevels"
  [actions]="actions"
>

  <!-- Main container -->
  <div *ngIf="!isLoading; else loading" class="container">
    <div class="left-sidebar">

     <div #scrollable class="scrollable">

       <!-- Image -->
       <div class="preview">
         <img *ngIf="!generateQRCode || !image; else qrCode" [src]="image || 'assets/img/no-image.png'" alt="Preview">
         <ng-template #qrCode>
           <qrcode [qrdata]="image.toString()" [width]="450" [errorCorrectionLevel]="'M'"></qrcode>
         </ng-template>
         <button *ngIf="canUploadImage" mat-flat-button class="upload-image" (click)="onUploadImageClick.emit(true)"><mat-icon color="primary">file_upload</mat-icon></button>
       </div>

       <!-- Sidebar content information -->
       <ng-content select="[sidebar-content]"></ng-content>

     </div>

      <!-- Sidebar actions -->
      <div class="actions" [class.withShadow]="hasScrollbar(scrollable)">
        <ng-content select="[sidebar-actions]"></ng-content>
      </div>

    </div>

    <!-- Main content -->
    <div class="content">

      <!-- Show empty content -->
      <div *ngIf="contentToShow == DetailCardContent.EMPTY" content class="new-item-overlay">
        <div>
          <ng-content  select="[empty-statement]"></ng-content>
        </div>
        <img src="assets/img/new-item.svg" alt="New item">
      </div>

      <!-- Show only content override -->
      <ng-content *ngIf="contentToShow == DetailCardContent.SINGLE_CONTENT" select="[content]"></ng-content>

      <!-- Tabs -->
      <mat-tab-group *ngIf="contentToShow == DetailCardContent.TABS" class="detail-page tabs">
        <mat-tab *ngFor="let tab of tabs" [label]="tab.name | translate">
          <div class="tab-content">
            <ng-container [ngTemplateOutlet]="tab.content"></ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>

    </div>
  </div>

</app-scotty-card>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
